/**
 * 存储localStorage
 */
export const setStore = (name, content) => {
	if(typeof content !== 'string') {
		content = JSON.stringify(content);
	}
	window.localStorage.setItem(name, content);
}

/**
 * 获取localStorage
 */
export const getStore = name => {
	return window.localStorage.getItem(name);
}

/**
 * 删除localStorage
 */
export const removeStore = name => {
	if(!name) return;
	window.localStorage.removeItem(name);
}

export const setState = 'setState'
export const getState = 'getState'
export default {
	setState(state, {
		attr,
		value,
		storeFlag
	}) {
		state[attr] = value;
		if(storeFlag) { //是否存入localStorage
			setStore(attr, value);
		}
	}
}


// WEBPACK FOOTER //
// ./src/store/mutations.js